import React from 'react';

export default function CompanyIcon() {
  return (
    <svg
      className="svg-icon"
      width="46px"
      height="36px"
      viewBox="0 0 46 36"
      role="img"
      aria-labelledby="company-icon-title"
    >
      <title id="company-icon-title">Company icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path
            d={
              'M22.9997081,7 L7.02801999,20.4240248 ' +
              'C7.02801999,20.4429703 7.02334999,20.470843 ' +
              '7.01401,20.5088331 C7.00486458,20.5465257 7,20.5739025 ' +
              '7,20.5933439 L7,34.1865887 C7,34.6773861 7.17600058,35.1027175 ' +
              '7.52790446,35.4608965 C7.87971104,35.8192739 8.29631386,35.9996032 ' +
              '8.77781021,35.9996032 L19.4438931,35.9996032 L19.4438931,25.12469 ' +
              'L26.5556204,25.12469 L26.5556204,36 L37.221606,36 C37.7030051,36 ' +
              '38.1201917,35.8200674 38.4715118,35.4608965 C38.8234157,35.1031143 ' +
              '39,34.6774853 39,34.1865887 L39,20.5933439 C39,20.5179587 ' +
              '38.9898817,20.461023 38.97198,20.4240248 L22.9997081,7 Z'
            }
          />
          <path
            d={
              'M45.6827046,16.5536186 L39.4345464,11.7332877 ' +
              'L39.4345464,0.92720079 C39.4345464,0.680163701 ' +
              '39.3490017,0.477005149 39.1773128,0.318003432 ' +
              'C39.0070229,0.159187249 38.7881645,0.0797791575 ' +
              '38.521437,0.0797791575 L33.0433807,0.0797791575 ' +
              'C32.776953,0.0797791575 32.5581945,0.159187249 ' +
              '32.3868054,0.318003432 C32.215816,0.477005149 ' +
              '32.1303713,0.680256467 32.1303713,0.92720079 ' +
              'L32.1303713,6.09178804 L25.1686747,0.688605449 ' +
              'C24.560668,0.229504227 23.8377356,0 23.0006771,0 ' +
              'C22.1637185,0 21.4408861,0.229504227 20.8322798,0.688605449 ' +
              'L0.317050654,16.5536186 C0.126873675,16.6946236 ' +
              '0.0226411009,16.8844238 0.00325364227,17.1228336 ' +
              'C-0.016033881,17.3610579 0.0504231293,17.569133 ' +
              '0.202824544,17.7455749 L1.97178024,19.7055447 ' +
              'C2.12418166,19.8643609 2.32365262,19.9614873 ' +
              '2.57099263,19.9970169 C2.79934491,20.0148281 ' +
              '3.02769719,19.9528601 3.25604948,19.8116695 ' +
              'L23.0000775,4.52913698 L42.7443053,19.8115767 ' +
              'C42.8968067,19.9347706 43.0961777,19.9962748 ' +
              '43.3435177,19.9962748 L43.4292623,19.9962748 ' +
              'C43.6762025,19.9613946 43.8752737,19.8636187 ' +
              '44.0284746,19.7051736 L45.7976302,17.7454821 ' +
              'C45.9497318,17.5686692 46.0163887,17.3609651 ' +
              '45.9966015,17.1224625 C45.9771141,16.8847021 ' +
              '45.8724818,16.6949019 45.6827046,16.5536186 Z'
            }
          />
        </g>
      </g>
    </svg>
  );
}
